import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Navbar from "../components/GeneralComponents/Navbar";
import SideNav from "../components/GeneralComponents/SideNav";
import Modal from "../components/Modal/Modal";
import { useAuth } from "./auth";
import { LogContent } from "./context";
import { routes } from "./misc";

export const RequireAuth = ({ children, requiresMeters = false }) => {
  const location = useLocation();
  const auth = useAuth();
  const { displayMeta } = useContext(LogContent);

  if (!auth.user) {
    return <Navigate to="/login" state={{ path: location.pathname }} />;
  }

  if (requiresMeters && auth.meterOwnerships.length === 0) {
    return <Navigate to={routes.manage_meters} />;
  }

  return (
    <div className="w-full">
      <div className="lg:flex lg:space-x-[50px] min-h-screen w-full">
        <SideNav className={"hidden lg:block"} />
        <div className="w-full">
          <Navbar />
          <div className="pl-0 lg:pl-[300px] w-full lg:pr-5">{children}</div>
        </div>
      </div>
      {displayMeta && <Modal />}
    </div>
  );
};
